
import React from 'react';
import { Github, Linkedin, Mail, MapPin, Clock } from "lucide-react";
import { Link as ScrollLink } from "react-scroll";
import { motion } from 'framer-motion';

const ImprovedFooter: React.FC = () => {
  return (
    <footer className="relative bg-black bg-opacity-90 py-12 mt-12 z-10 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-white mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h4 className="text-xl font-bold text-yellow-300 mb-6 flex items-center">
              <span className="inline-block w-8 h-1 bg-yellow-300 mr-2"></span>
              Quick Links
            </h4>
            <ul className="space-y-3">
              {["welcome", "skills", "projects", "contact"].map((section) => (
                <li key={section}>
                  <ScrollLink
                    to={section}
                    smooth={true}
                    duration={500}
                    className="cursor-pointer text-gray-300 hover:text-yellow-300 transition-colors flex items-center"
                  >
                    <span className="inline-block w-2 h-2 bg-yellow-300 rounded-full mr-2 transform transition-transform duration-300 hover:scale-150"></span>
                    {section.charAt(0).toUpperCase() + section.slice(1)}
                  </ScrollLink>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <h4 className="text-xl font-bold text-yellow-300 mb-6 flex items-center">
              <span className="inline-block w-8 h-1 bg-yellow-300 mr-2"></span>
              Connect With Me
            </h4>
            <div className="space-y-4">
              <a
                href="https://github.com/healer3771?tab=repositories"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-300 hover:text-yellow-300 transition-colors group"
              >
                <div className="p-3 bg-gray-800 rounded-full group-hover:bg-gray-700 transition">
                  <Github className="w-5 h-5" />
                </div>
                <span>GitHub</span>
              </a>
              
              <a
                href="https://www.linkedin.com/in/qadeerah/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-300 hover:text-yellow-300 transition-colors group"
              >
                <div className="p-3 bg-gray-800 rounded-full group-hover:bg-gray-700 transition">
                  <Linkedin className="w-5 h-5" />
                </div>
                <span>LinkedIn</span>
              </a>
              
              <a
                href="mailto:qadahma@gmail.com"
                className="flex items-center gap-3 text-gray-300 hover:text-yellow-300 transition-colors group"
              >
                <div className="p-3 bg-gray-800 rounded-full group-hover:bg-gray-700 transition">
                  <Mail className="w-5 h-5" />
                </div>
                <span>qadahma@gmail.com</span>
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4 className="text-xl font-bold text-yellow-300 mb-6 flex items-center">
              <span className="inline-block w-8 h-1 bg-yellow-300 mr-2"></span>
              Contact Info
            </h4>
            <div className="space-y-4">
              <div className="flex items-center gap-3 text-gray-300">
                <div className="p-3 bg-gray-800 rounded-full">
                  <MapPin className="w-5 h-5" />
                </div>
                <span>Newark, New Jersey, USA</span>
              </div>
              
              <div className="flex items-center gap-3 text-gray-300">
                <div className="p-3 bg-gray-800 rounded-full">
                  <Clock className="w-5 h-5" />
                </div>
                <span>Available for new opportunities</span>
              </div>
            </div>
            
            <p className="text-gray-400 text-sm mt-6 border-t border-gray-800 pt-6">
              &copy; {new Date().getFullYear()} Qadeer Ahmad. All Rights Reserved.
            </p>
          </motion.div>
        </div>
        
        <div className="text-center pt-6 border-t border-gray-800">
          <p className="text-gray-500 text-sm">
            Designed and built with ❤️ using React & Tailwind CSS
          </p>
        </div>
      </div>
    </footer>
  );
};

export default ImprovedFooter;
